import { Component, Input, OnInit } from "@angular/core";
@Component({
  selector: "app-identify-feature",
  templateUrl: "./identify-feature.component.html",
  styleUrls: ["./identify-feature.component.scss"],
})
export class IdentifyFeatureComponent implements OnInit {
  @Input() featuresInfo: any;
  constructor() {}

  ngOnInit() {}
}
